import { optionTitle_readingPane } from './ReadingPaneOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let ReadingPaneOption: LazyOption = createLazyOption(
    {
        key: 'readingPane',
        titleStringKey: optionTitle_readingPane,
        searchTermsStringKey: optionTitle_readingPane,
        allowedOptionKeys: ['MessageOptions', 'ReadingPane'],
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default ReadingPaneOption;
